import { ServiceStoreConfig } from "../types/ServiceStoreTypes";

/**
 * Whiteboard domain — the team's delivery + sales whiteboard brought in-app
 * (views/whiteboard). Four flat CRUD services, every one on the API's staff
 * broadcast (realtime/apiPublishParity.test.ts holds that), so the board's
 * lists — computed over these caches — move when anyone edits:
 *
 *   - `whiteboard-rows`     → one LANE per delivery/sales/internal workstream;
 *                             `clientId` ties a lane to Client 360 (nullable for
 *                             internal lanes and not-yet-client prospects)
 *   - `whiteboard-cells`    → one lane's note for ONE week (weekOf = the Monday,
 *                             'YYYY-MM-DD'), colored by the whiteboard's
 *                             four-status language
 *   - `whiteboard-items`    → a lane's weekly goals, milestones and blockers,
 *                             each with an owner (#3383)
 *   - `whiteboard-statuses` → the Sales Queue's deal statuses, admin-edited
 *                             (#3080 / #2662)
 *
 * Consumed by WhiteboardStore (the board) and ClientDetailStore (the Client
 * 360 "Whiteboard" tab, clientId-scoped).
 */
export const whiteboardStores: ServiceStoreConfig[] = [
  { name: "whiteboard-rows", options: { idField: "id", enableStorage: false } },
  { name: "whiteboard-cells", options: { idField: "id", enableStorage: false } },
  { name: "whiteboard-items", options: { idField: "id", enableStorage: false } },
  { name: "whiteboard-statuses", options: { idField: "id", enableStorage: false } },
];

/**
 * The find-only accepted-work rollup (#2516): one row per client with a lane,
 * keyed by `clientId` (it has no `id`), computed from HQ's action-item records
 * and stored nowhere. It emits no events, so it is NOT in the list above (that
 * list is the broadcast set); WhiteboardStore re-reads it when an action item
 * is accepted or completed anywhere in HQ.
 */
export const whiteboardRollupStores: ServiceStoreConfig[] = [
  { name: "whiteboard-lane-work", options: { idField: "clientId", enableStorage: false } },
];
